import React, { ReactElement } from 'react'
import ActionToggle from 'live/components/ui/action-toggle'

type Props = {
    label: string
    value: boolean
    configKey: string
    onChange: (configKey: string, newValue: boolean) => void
}

export default function Toggle(props: Props): ReactElement {
    return (
        <div className="config-form is-checkbox verticalEnabled action-toogle " style={{ marginBottom: '2px' }}>
            <ActionToggle onChange={() => props.onChange(props.configKey, !props.value)} active={props.value} />
            {props.label}
        </div>
    )
}
